import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import useHandoutProductStore from "src/store/relatedProduct";
import { useLegacyPassLogic } from "./legacy/useLegacyPassLogic";
import PassMenuList from "./PassMenuList";
import PassSelectButton from "./PassSelectButton";
import PurchaseCTA from "./PurchaseCTA";
import { TabFormSection } from "./PurchaseLayouts";
import PurchaseNoFreepassTab from "./PurchaseNoFreepassTab";
import useMembershipQuery from "./useMembershipQuery";
import { usePassSelect } from "./usePassSelect";
const PurchaseFreePassTab = (param)=>{
    let { isLoggedIn , product , fullWidth  } = param;
    const { handleUsePass  } = useLegacyPassLogic({
        product,
        skipConfirmation: true
    });
    const { selectedPurchaseOption  } = useHandoutProductStore((state)=>({
            selectedPurchaseOption: state.selectedPurchaseOption
        }));
    const { data: passes = [] , isSuccess  } = useMembershipQuery({
        productId: product.id,
        isLoggedIn,
        freepassOnly: true,
        selectedPurchaseOption: selectedPurchaseOption
    });
    const { anchorEl , menuWidth , menuListOpen , selectedPass , handleSelectClick , handleSelectClose , handlePassSelect  } = usePassSelect(passes, fullWidth);
    const isAllFreepassDisabled = isSuccess && passes.every((pass)=>pass.isDisabled);
    if (isAllFreepassDisabled) {
        return /*#__PURE__*/ _jsx(PurchaseNoFreepassTab, {
            product: product
        });
    }
    var _selectedPass_id;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(TabFormSection, {
                sx: {
                    mb: 2
                },
                title: "이용권 선택",
                children: [
                    /*#__PURE__*/ _jsx(PassSelectButton, {
                        open: menuListOpen,
                        onClick: handleSelectClick,
                        pass: selectedPass
                    }),
                    /*#__PURE__*/ _jsx(PassMenuList, {
                        anchorEl: anchorEl,
                        onClose: handleSelectClose,
                        open: menuListOpen,
                        menuWidth: menuWidth,
                        passes: passes,
                        onPassSelect: handlePassSelect,
                        selectedId: (_selectedPass_id = selectedPass === null || selectedPass === void 0 ? void 0 : selectedPass.id) !== null && _selectedPass_id !== void 0 ? _selectedPass_id : null
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(PurchaseCTA, {
                variant: "freepass",
                onClick: handleUsePass
            })
        ]
    });
};
export default PurchaseFreePassTab;
